module.exports = __webpack_public_path__ + "static/curry-ea009d82f46d1b59ca4a82b20cda6448.jpeg";